import React from 'react';
import { Container } from '@mui/material';
import SacolaVisualizarComponent from '../components/sacola/SacolaVisualizar';

const SacolaVisualizarPage: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <SacolaVisualizarComponent />
    </Container>
  );
};

export default SacolaVisualizarPage;
